import { AxiosResponse } from 'axios';
import { Terminal as ShippingTerminal } from 'types/Shipping';
import { objectKeysToCamelCase, joinArrayParams } from 'utils/common';
import axiosWithToken from './axios-with-token';
import { Port } from './ports';
import { Region } from './regions';

export enum TerminalQueryKeys {
  Terminals = 'terminals',
  TerminalsByPort = 'terminalsByPort',
}

interface PortRemote {
  name: string;
}

export enum AppointmentRule {
  RegistrationRequired = 'registration_required',
  ConfirmationRequired = 'confirmation_required',
  AppointmentBeforeOne = 'appointment_before_one',
  AppointmentRequired = 'appointment_required',
  PreArrivalRequired = 'pre_arrival_required',
  NoAppointmentRequired = 'no_appointment_required',
  DoNotDisplayAppointmentInCell = 'do_not_display_appointment_in_cell',
}

// exported for a js dependency
export const doNotDisplayRule = AppointmentRule.DoNotDisplayAppointmentInCell;

export interface TerminalRemote {
  appointment_rules: AppointmentRule[];
  appointment_system_name: string;
  key: string;
  location: string;
  logo: string;
  name: string;
  no_data_appointments: boolean;
  no_data: boolean;
  pier: string;
  port_name: string;
  port: null | PortRemote;
  portal: number;
  terminal_portal: string;
  website: string;
}

export interface Terminal extends ShippingTerminal {
  port: Port;
  appointmentRules: AppointmentRule[];
}

export async function fetchTerminals(values: {
  signal?: AbortSignal;
  onlyTrackAndTrace?: boolean;
  portCollectionCodes?: Region['code'][];
}) {
  const { signal, portCollectionCodes = [], onlyTrackAndTrace = false } = values;
  const response: AxiosResponse<TerminalRemote[]> = await axiosWithToken.get(
    '/core/api/v1/erl/port',
    {
      params: {
        port_collection_codes: joinArrayParams(portCollectionCodes),
        only_track_and_trace: onlyTrackAndTrace,
      },
      signal,
    }
  );
  const terminals: Terminal[] = objectKeysToCamelCase(response.data);
  return terminals;
}

export async function fetchTerminalsByPort(values: {
  signal?: AbortSignal;
  port?: string;
  onlyTrackNTrace?: boolean;
}) {
  const { signal, port, onlyTrackNTrace = false } = values;
  const response: AxiosResponse<TerminalRemote[]> = await axiosWithToken.get(
    '/core/api/v1/erl/terminals',
    {
      params: {
        port,
        only_track_n_trace: onlyTrackNTrace,
      },
      signal,
    }
  );
  const terminals: Terminal[] = objectKeysToCamelCase(response.data);
  return terminals;
}
